import React, { useEffect } from 'react';
import { InputNumber, Form } from 'antd';
import { JSX } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function IzmenitPromokodiVYacheikakh(props) {
    const { object, form, parentObject } = props;
    useEffect(() => {
        form.resetFields();
    }, []);
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <div style={{ paddingBottom: "10px" }}>
                    {/* {JSX(() => { console.log(object) })} */}
                    {(object) && <div>
                        {object?.promokod &&
                            <div style={{ display: "flex", gap: "5px" }}>
                                {JSX(()=>{console.log(object.promokod)})}
                                <div>
                                    <span style={{ fontWeight: "300" }}>Промокод: </span>
                                </div>
                                <div>
                                    <div>
                                        <span>{object?.promokod?.promokod}</span>
                                    </div>
                                    {object?.promokod?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.promokod?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(object?.promokod?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(object?.promokod?.meropriyatie?.mestoProvedeniya) ? "(" + object?.promokod?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                                    </div>}
                                    {object?.promokod?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>Федерация</span>
                                    </div>}
                                    {object?.promokod?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.promokod?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                    </div>}
                                    {object?.promokod?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.promokod?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                    </div>}
                                    {object?.promokod?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.promokod?.organizatorMeropriyatiya?.nazvanie}</span>
                                    </div>}
                                </div>
                            </div>
                        }
                        {(object?.yacheikaUslugi?.nazvanie) && <div>
                            <div style={{ display: "flex", gap: "5px" }}>
                                {/* {JSX(()=>{console.log(object)})} */}
                                <div>
                                    <span style={{ fontWeight: "300" }}>Услуга: </span>
                                </div>
                                <div>
                                    <div>
                                        <span>{object?.yacheikaUslugi?.nazvanie}</span>
                                    </div>
                                    {object?.yacheikaUslugi?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.yacheikaUslugi?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(object?.yacheikaUslugi?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(object?.yacheikaUslugi?.meropriyatie?.mestoProvedeniya) ? "(" + object?.yacheikaUslugi?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                                    </div>}
                                    {object?.yacheikaUslugi?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>Федерация</span>
                                    </div>}
                                    {object?.yacheikaUslugi?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.yacheikaUslugi?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                    </div>}
                                    {object?.yacheikaUslugi?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.yacheikaUslugi?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                    </div>}
                                    {object?.yacheikaUslugi?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                        <span>{object?.yacheikaUslugi?.organizatorMeropriyatiya?.nazvanie}</span>
                                    </div>}
                                </div>
                            </div>
                        </div>}
                    </div>}
                </div>
                <Form.Item label="Процент"
                    name="protsentObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Сумма"
                    name="rubleiOtObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber />
                </Form.Item>
            </Form>
        </>
    );
}
